export interface Company {
  name: string;
  id: number;
}
